import { createPortal } from 'react-dom';
import styles from './pane-scrim.module.css';

// Render this inside any scrim that composes `paneScrim` (pane-scrim.module.css). That scrim
// stops at the nav rail's edge so the rail stays crisp per the Figma; this transparent layer
// covers the rail so the dialog is still genuinely modal — the rail can't be hovered or
// clicked through, and a press on it dismisses like a press anywhere else outside the card.
//
// It portals to <body> rather than rendering in place for a concrete reason: the scrim carries
// `backdrop-filter`, which makes it the containing block for a `position: fixed` descendant.
// Left inside, the catcher would anchor to the scrim instead of the viewport and never reach
// the rail at all.
//
// `zIndex` must match the scrim's so the two read as one layer.
export function RailCatcher({ onClose, zIndex }: { onClose: () => void; zIndex: number }) {
  return createPortal(
    <div
      aria-hidden
      className={styles.railCatcher}
      style={{ zIndex }}
      // A React portal still bubbles through the React tree, so without this the scrim's own
      // mousedown handler also sees the press. Harmless today, but it would quietly double-fire.
      onMouseDown={(e) => {
        e.stopPropagation();
        onClose();
      }}
    />,
    document.body,
  );
}
